var map = {
	"./alcohol.svg": "3e22",
	"./building.svg": "8c51",
	"./calendar-alt-solid.svg": "c985",
	"./card.svg": "2d9e",
	"./carousel.svg": "f3a0",
	"./children.svg": "264c",
	"./circle.svg": "091a",
	"./city-solid.svg": "d4ee",
	"./coupon.svg": "e24d",
	"./dashboard.svg": "f782",
	"./directories.svg": "9613",
	"./el-one.svg": "8291",
	"./el-three.svg": "0128",
	"./el-two.svg": "f5ec",
	"./elementor-brands.svg": "210b",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./file-audio-solid.svg": "c3f5",
	"./files.svg": "550e",
	"./form.svg": "eb1b",
	"./images.svg": "b0cb",
	"./link.svg": "18f0",
	"./link2.svg": "26b0",
	"./mask-solid.svg": "2d72",
	"./mobile.svg": "30d4",
	"./nested.svg": "dcf8",
	"./new-product.svg": "3962",
	"./news.svg": "c862",
	"./notification.svg": "1ca6",
	"./page.svg": "7db2",
	"./palette-solid.svg": "fd6b",
	"./partner.svg": "f654",
	"./password.svg": "2a3d",
	"./people.svg": "d056",
	"./products.svg": "0e1b",
	"./segmentation.svg": "4712",
	"./server.svg": "cda5",
	"./settings.svg": "3fc8",
	"./sticker.svg": "2b44",
	"./table.svg": "47f1",
	"./targets-products.svg": "e3b4",
	"./targets.svg": "1a45",
	"./transfer.svg": "e1d1",
	"./tree.svg": "93cd",
	"./truck.svg": "364d",
	"./user.svg": "b3b5",
	"./web.svg": "d02d",
	"./yoomoney.svg": "735e",
	"./youtube-brands.svg": "bba0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";